module.exports = __webpack_public_path__ + "static/media/Janpa.d3b223da.svg";